import api from "../services/AccountService";
import ClientError from "../utils/errorLogger";
import { getSessionStorage } from "../utils/storageSecurity";


//login action creator
export const login = async (data) => {

  try {
    const loginData = await api.post("/account/signin", JSON.stringify(data));
    return loginData;
  } catch (error) {
    /// return statement was removed from ClientError because its not able to throw any error that will generate Invalid Login Message
    ClientError(error.message, window.location, `${error.config.baseURL}${error.config.url}`, error.request, error.response);
    throw error;
  }
};

export const refreshToken = async () => {
  // const userData = JSON.parse(getSessionStorage("userData"));
  const userData = JSON.parse(getSessionStorage("userData"));
  // const statusData = JSON.parse(sessionStorage.getItem("statusData"));
  //const statusData = JSON.parse(getSessionStorage("statusData"));


  const postData = {
    // refreshToken: sessionStorage.getItem("refreshToken"),
    CLIENTID: userData?.CLIENTID,
    USERNAME: userData?.UserN,
    EMPCODE: userData?.EMPCODE
  };
  const data = {
    key: "",
    dataobj: "",
    jsonstring: JSON.stringify(postData),
  };

  try {
    const response = await api.post(
      "/account/RefreshToken",
      JSON.stringify(data)
    );
    const { token } = response.data;
    sessionStorage.setItem("token", token);
    //sessionStorage.setItem("refreshToken", response?.data?.refreshToken);
    return token;
  } catch (error) {
    return ClientError(error.message, window.location, `${error.config.baseURL}${error.config.url}`, error.response);
  }
};

export const insertEnt = async (params) => {
  let userData = JSON.parse(getSessionStorage("userData"));
  const configData = {
    // CLIENTID: sessionStorage.getItem("clientId"),
    CLIENTID: JSON.parse(getSessionStorage("clientId")),
    BU: userData.BU,
    MENUCODE: params.menucode,
    EMPCODE: userData.EMPCODE,
    // TaskForce: userData.TASKFORCE,
    // Rolecode: userData.ROLECODE,
    HOST: params?.host,
    BROWESER: params?.browser,
    DEVICE: params?.device,
    PROJFLAG: params?.projflg
  };

  const Configuredata = {
    key: "",
    dataobj: "",
    jsonstring: JSON.stringify(configData),
  };
  try {
    return await api.post("/v1/account/LogEntry", JSON.stringify(Configuredata));
  } catch (error) {
    ClientError(error.message, window.location, `${error.config.baseURL}${error.config.url}`, error.response);
    throw error;
  }
};
//Forgot action creator

export const Forgot = async (params) => {

  const configData = {
    // CLIENTID: sessionStorage.getItem("clientId"),
    CLIENTID: params.CLIENTID,
    // REPCODE:userData.REPCODE,
    USERNAME: params.USERNAME
  };

  const Configuredata = {
    key: "",
    dataobj: "",
    jsonstring: JSON.stringify(configData),
  };
  try {
    return await api.post("/account/Forgot", JSON.stringify(Configuredata));
  } catch (error) {
    ClientError(error.message, window.location, `${error.config.baseURL}${error.config.url}`, error.response);
    throw error;
  }
};

export const CheckPass = async (params) => {

  const configData = {
    CLIENTID: params.CLIENTID,
    REPSNAME: params.uid,
    entryno: params.entryno,

  };

  const Configuredata = {
    key: "",
    dataobj: "",
    jsonstring: JSON.stringify(configData),
  };
  try {
    return await api.post("/account/CheckPass", JSON.stringify(Configuredata));
  } catch (error) {
    ClientError(error.message, window.location, `${error.config.baseURL}${error.config.url}`, error.response);
    throw error;
  }
};

export const getFillGuidelines = async (params) => {

  const configData = {
    CLIENTID: params.CLIENTID,


  };

  const Configuredata = {
    key: "",
    dataobj: "",
    jsonstring: JSON.stringify(configData),
  };
  try {
    return await api.post("/v1/account/FillGuidelines", JSON.stringify(Configuredata));
  } catch (error) {
    ClientError(error.message, window.location, `${error.config.baseURL}${error.config.url}`, error.response);
    throw error;
  }
};
export const MpowerResetnew = async (params, entryno) => {

  const configData = {
    CLIENTID: entryno[2],
    REPSNAME: entryno[1],
    Newpassword: params.NPWD,
    entryno: entryno[0],

  };

  const Configuredata = {
    key: "",
    dataobj: "",
    jsonstring: JSON.stringify(configData),
  };
  try {
    return await api.post("/account/MpowerResetnew", JSON.stringify(Configuredata));
  } catch (error) {
    ClientError(error.message, window.location, `${error.config.baseURL}${error.config.url}`, error.response);
    throw error;
  }
};

export const ResetPasswordData = async (data1) => {

  let userData = JSON.parse(getSessionStorage("userData"));
  const postData = {
    CLIENTID: userData.CLIENTID,
    EMPCODE: userData.EMPCODE,
    OLDPWD: data1?.OldPassword,
    NEWPWD: data1?.NewPassword
  };
  const data = {
    key: "",
    dataobj: "",
    jsonstring: JSON.stringify(postData),
  };
  try {
    const response = await api.post(
      "/account/ResetPassword",
      JSON.stringify(data)
    );
    return response
  } catch (error) {
    return ClientError(error.message, window.location, `${error.config.baseURL}${error.config.url}`, error.response, error.request);
  }
};

export const SSOSignIn = async (data) => {

  try {
    const loginData = await api.post("/account/SSOSignIn", JSON.stringify(data));
    return loginData;
  } catch (error) {
    /// return statement was removed from ClientError because its not able to throw any error that will generate Invalid Login Message
    ClientError(error.message, window.location, `${error.config.baseURL}${error.config.url}`, error.request, error.response);
    throw error;
  }
};
export const GetLoginData = async (data1) => {
  const postData = {
    CLIENTID: data1.CLIENTID,
    USERNAME: data1.email,
  };
  const data = {
    key: "",
    dataobj: "",
    jsonstring: JSON.stringify(postData),
  };
  try {
    const response = await api.post(
      "/account/GetLoginData",
      JSON.stringify(data)
    );
    return response
  } catch (error) {
    return ClientError(error.message, window.location, `${error.config.baseURL}${error.config.url}`, error.response, error.request);
  }
};
export const GetTokenData = async (data1) => {
  const postData = {
    CLIENTID: data1.CLIENTID,
    USERNAME: data1.email,
    AuthCode: data1.authCode,
    SsoClientId: data1.ssoClientId?.toUpperCase()
  };
  const data = {
    key: "",
    dataobj: "",
    jsonstring: JSON.stringify(postData),
  };
  try {
    const response = await api.post(
      "/account/GetTokenData",
      JSON.stringify(data),
      { withCredentials: true }
    );
    return response
  } catch (error) {
    return ClientError(error.message, window.location, `${error.config.baseURL}${error.config.url}`, error.response, error.request);
  }
};
export const GetGoogleRefresh = async (data1) => {
  const userData2 = JSON.parse(getSessionStorage("userData"));
  const postData = {
    CLIENTID: userData2.CLIENTID,
    EMPCODE: userData2.EMPCODE,
  };
  const data = {
    key: "",
    dataobj: "",
    jsonstring: JSON.stringify(postData),
  };
  try {
    const response = await api.post(
      "/account/GoogleRefresh",
      JSON.stringify(data),
      { withCredentials: true }
    );
    return response
  } catch (error) {
    return ClientError(error.message, window.location, `${error.config.baseURL}${error.config.url}`, error.response, error.request);
  }
};

